// extracted by mini-css-extract-plugin
export default {"lato-family":"BannerImage_lato-family__DaRJP","banner-image-container":"BannerImage_banner-image-container__2DH83"};